/**
 * Custom fields reducer
 */

import { Portal, PortalItemType } from "@thenounproject/lingo-core";

import createEntityReducer from "../helpers/createEntityReducer";
import { createPortal } from "@redux/actions/kits/useCreatePortal";
import { fetchPortals } from "@redux/actions/portals/usePortals";
import { deletePortal } from "@redux/actions/portals/useDeletePortal";
import { createPortalItems } from "@redux/actions/portalItems/useCreatePortalItems";
import { deletePortalItems } from "@redux/actions/portalItems/useDeletePortalItems";
import { getEntitiesFromAction, mergeEntitiesIfChanged } from "../helpers/mergeIfChanged";

export default createEntityReducer<Portal>(
  "portals",
  queryBuilder => {
    queryBuilder
      .addCase(createPortal.fulfilled, (state, action) => {
        const newPortal = action.payload.entities.portals[action.payload.result];
        const { spaceId } = newPortal;

        fetchPortals.getQueryData(state, { spaceId }).forEach(query => {
          query.data.portals.push(action.payload.result);
          query.data.total += 1;
        });
      })
      .addCase(deletePortal.fulfilled, (state, action) => {
        const deletedPortal = action.payload.entities.portals[action.payload.result];
        const { spaceId } = deletedPortal;

        fetchPortals.getQueryData(state, { spaceId }).forEach(query => {
          query.data.portals = query.data.portals.filter(id => id !== deletedPortal.id);
          query.data.total -= 1;
        });
      });
  },
  objectBuilder => {
    objectBuilder
      // update kit count when a new kit is created or deleted for dashboard count
      .addCase(createPortalItems.fulfilled, (state, action) => {
        const portalKitItems = Object.values(action.payload.entities.portalItems ?? {}).filter(
          item => item.type === PortalItemType.kit
        );
        if (!portalKitItems.length) return;
        portalKitItems.forEach(item => {
          if (state[item.portalId]) {
            state[item.portalId].counts.kits += 1;
          }
        });
      })
      .addCase(deletePortalItems.fulfilled, (state, action) => {
        const portalKitItems = Object.values(action.payload.entities.portalItems ?? {}).filter(
          item => item.type === PortalItemType.kit
        );
        if (!portalKitItems.length) return;
        portalKitItems.forEach(item => {
          if (state[item.portalId]) {
            state[item.portalId].counts.kits -= 1;
          }
        });
      })
      .addDefaultCase((state, action) => {
        const portals = getEntitiesFromAction<Portal>(action, "portals");
        mergeEntitiesIfChanged(state, portals, (objValue, srcValue, key) => {
          if (key === "theme") {
            return srcValue ?? objValue;
          }
          if (key === "images") {
            return srcValue ?? objValue;
          }
        });
      });
  }
);
